import axios from 'axios'
import { url } from '../constants/config'

export function getContractAbi() {
  return axios.get(url.contract_abi_url).then(response => {
    return {
      success: true,
      message: response.data
    }
  }).catch(error => {
    return {
      success: false,
      message: error.response?.data
    }
  })
}

export function getMetadataNFT(token) {
  return axios.get(url.storage_metadata_url + '/' + token).then(response => {
    return {
      success: true,
      message: response.data
    }
  }).catch(error => {
    return {
      success: false,
      message: error.response?.data
    }
  })
}

export function checkMintedNFT(token) {
  return axios.get(url.api_mint_nft + '/' + token).then(response => {
    return {
      success: true,
      message: response.data
    }
  }).catch(error => {
    return {
      success: false,
      message: error.response?.data
    }
  })
}

export function getAllNFT(status, listedTimeGTE, listedTimeLTE, currency, priceGTE, priceLTE, collection, rarity) {
  let query = '?'
  if (status) query = query + 'status=' + status + '&'
  else query = query + 'status=LISTED&status=AUCTION&'
  if (listedTimeGTE) query = query + 'listed_time_gte=' + listedTimeGTE + '&'
  if (listedTimeLTE) query = query + 'listed_time_lte=' + listedTimeLTE + '&'
  if (currency) query = query + 'currency=' + currency + '&'
  if (priceGTE) query = query + 'price_gte=' + priceGTE + '&'
  if (priceLTE) query = query + 'price_lte=' + priceLTE + '&'
  if (collection) query = query + 'collection=' + collection + '&'
  if (rarity) query = query + 'rarity=' + rarity + '&'

  return axios.get(url.marketplace_url + '/nft' + query).then(response => {
    return {
      success: true,
      message: response.data
    }
  }).catch(error => {
    return {
      success: false,
      message: error.response?.data
    }
  })
}

export function searchNFT(query) {
  return axios.get(url.marketplace_url + '/nft?q=' + encodeURIComponent(query)).then(response => {
    return {
      success: true,
      message: response.data
    }
  }).catch(error => {
    return {
      success: false,
      message: error.response?.data
    }
  })
}

export function getAllLikeNFT(accessToken, listId) {
  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  }
  return axios.post(url.marketplace_url + '/like-status', listId, config).then(response => {
    return {
      success: true,
      message: response.data
    }
  }).catch(error => {
    return {
      success: false,
      message: error.response?.data
    }
  })
}

export function getMyNFT(address) {
  return axios.get(url.marketplace_url + '/nft?status=ALL&owner=' + address).then(response => {
    return {
      success: true,
      message: response.data
    }
  }).catch(error => {
    return {
      success: false,
      message: error.response?.data
    }
  })
}

export function getNFTDetail(token) {
  return axios.get(url.marketplace_url + '/nft/' + token).then(response => {
    return {
      success: true,
      message: response.data
    }
  }).catch(error => {
    return {
      success: false,
      message: error.response?.data
    }
  })
}

export function registerInvestor(name, email, title, content) {
  const params = {
    name,
    email,
    title,
    content
  }
  return axios.post(url.holysharks_url + '/investor-mail/contact', params).then(response => {
    return {
      success: true,
      message: response.data
    }
  }).catch(error => {
    return {
      success: false,
      message: error.response?.data
    }
  })
}

export function loginAccount(message, signature) {
  const params = {
    message,
    signature
  }
  return axios.post(url.holysharks_url + '/auth/login', params).then(response => {
    return {
      success: true,
      message: response.data
    }
  }).catch(error => {
    return {
      success: false,
      message: error.response?.data
    }
  })
}

export function checkExpireToken(accessToken) {
  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  }

  return axios.get(url.holysharks_url + '/auth/validate-token', config).then(response => {
    if (response.data.success) {
      return {
        success: true,
        message: response.data
      }
    }
    else return {
      success: false,
      message: response.data
    }
  }).catch(error => {
    return {
      success: false,
      message: error.response?.data
    }
  })
}

export function getFavoriteNFT(accessToken) {
  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  }

  return axios.get(url.holysharks_url + '/marketplace/favorite-nft', config).then(response => {
    return {
      success: true,
      message: response.data
    }
  }).catch(error => {
    return {
      success: false,
      message: error.response?.data
    }
  })
}

export function likeNFT(nftId, accessToken) {
  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  }

  return axios.post(url.holysharks_url + '/marketplace/like/' + nftId, null ,config).then(response => {
    return {
      success: true,
      message: response.data
    }
  }).catch(error => {
    return {
      success: false,
      message: error.response?.data
    }
  })
}

export function unlikeNFT(nftId, accessToken) {
  const config = {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  }

  return axios.post(url.holysharks_url + '/marketplace/unlike/' + nftId, null, config).then(response => {
    return {
      success: true,
      message: response.data
    }
  }).catch(error => {
    return {
      success: false,
      message: error.response?.data
    }
  })
}